import { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const WHATSAPP_NUMBER = '971503847865';
const DEFAULT_MESSAGE = 'Hi! I have a question about dxb2bom products.';

const FloatingWhatsApp = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleClick = () => {
    const message = encodeURIComponent(DEFAULT_MESSAGE);
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;
    window.open(url, '_blank');
  };

  return (
    <>
      {/* WhatsApp Button Container - positioned to cover badge on desktop */}
      <div className="fixed bottom-20 md:bottom-2 right-4 md:right-2 z-[9999]">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          className="relative"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          {/* Tooltip */}
          <AnimatePresence>
            {showTooltip && (
              <motion.div
                initial={{ opacity: 0, x: 10 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 10 }}
                className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-white rounded-lg shadow-lg border border-slate-200 px-4 py-2 whitespace-nowrap"
              >
                <p className="text-sm font-medium text-slate-900">Need help?</p>
                <p className="text-xs text-slate-500">Chat with us on WhatsApp</p>
                <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1 w-2 h-2 bg-white border-r border-t border-slate-200 rotate-45" />
              </motion.div>
            )}
          </AnimatePresence>

          {/* WhatsApp Button - larger on desktop to cover badge */}
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={handleClick}
            className="relative h-12 w-12 md:h-12 md:w-44 rounded-full md:rounded-xl bg-[#25D366] hover:bg-[#20BA5C] shadow-lg shadow-green-900/30 flex items-center justify-center gap-2 transition-colors"
            data-testid="whatsapp-btn"
          >
            <MessageCircle className="w-6 h-6 text-white" fill="white" />
            <span className="hidden md:inline text-white font-semibold text-sm">Chat with us</span>
            
            {/* Pulse animation - only on mobile */}
            <span className="md:hidden absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
          </motion.button>

          {/* Online indicator */}
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-green-400 rounded-full border-2 border-white">
            <span className="absolute inset-0 rounded-full bg-green-400 animate-pulse" />
          </span>
        </motion.div>
      </div>
    </>
  );
};

export default FloatingWhatsApp;
